module.exports = __webpack_public_path__ + "static/media/waterfall.f847ba2e.jpeg";